import { Component, OnInit } from '@angular/core';
import { BreadcrumbsService } from '../../services/utils/breadcrumbs.service';
import { KeycloakService } from 'keycloak-angular';
import { Role } from '../../utils/Role';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss']
})
export class ResourcesComponent implements OnInit {

  userRoles: string[];
  allRoles: any;

  constructor(
    private breadcrumbsService: BreadcrumbsService,
    private keycloakService: KeycloakService,
    private router: Router,
    private titleService: Title
  ) {

  }

  ngOnInit() {
    if (this.titleService.getTitle().includes(" - ")) {
      this.titleService.setTitle(this.titleService.getTitle().split(" - ")[1]);
    }

    this.allRoles = Role;
    this.userRoles = this.keycloakService.getUserRoles();
    //this.userRoles = [Role.Catalog, Role.Coverage, Role.Orders, Role.Products, Role.Resources, Role.Tasks, Role.Templates];
    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs:
          [
            { title: 'Recursos', url: 'provision/resources' },
          ]
      }
    );
  }

  goToResources() {
    this.router.navigate([`/provision/resources/ftth/search`]);
  }

}
